import { TranslateService } from '@ngx-translate/core';
import {Component, OnInit} from '@angular/core';
import {BrandService} from '../../../services/brand/brand.service';
import {DataTableService} from '../../../modules/UIKit/components/dataTable/dataTable.service';
import {Brand} from '../../../models/brand.model';

@Component({
  selector: 'app-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.css'],
  providers: []
})
export class BrandComponent implements OnInit {

  public brands: Brand[];
  modalTitle = '';
  labels = {};

  constructor (
    public srvBrand: BrandService,
    private srvDataTable: DataTableService,
    private translate: TranslateService
  ) { }

  reloadList() {
    this.brands = [];
    this.srvBrand.getAll().subscribe( res => {
      this.brands = res;
    });
  }

  ngOnInit() {
    this.reloadList();

    this.translate.get([
      'brandList.add_title',
      'brandList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['brandList.add_title'];
      this.labels['edit_title'] = res['brandList.edit_title'];
    });

  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.srvBrand.brandEditing = data == null ? new Brand() : data;
  }

  delete(record): void {
    this.srvBrand.delete(record).subscribe(() => {
      this.reloadList()
    });
  }

  recoverBrand(record){
    this.srvBrand.recover(record).subscribe(() => {
      this.reloadList()
    });
  }

  brandAdded($event): void {
    this.srvBrand.post($event).subscribe(() => {
      this.srvDataTable.get('dt_brand').showDetail = false;
      this.srvBrand.brandEditing = null;
      this.reloadList()
    });
  }

  brandUpdated($event): void {
    this.srvBrand.put($event, this.srvBrand.brandEditing.id).subscribe(() => {
        this.srvDataTable.get('dt_brand').showDetail = false;
        this.srvBrand.brandEditing = null;
        this.reloadList()
      }
    )
  }

  closeDialog() {
    this.srvBrand.brandEditing = null;
    this.reloadList()
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/brand/brand.component.ts